import "./App.css";
import Header from "./components/Header";
import Home from "./components/Home";
import About from "./components/About";
import Skills from "./components/Skills";
import Services from "./components/Services";
import Qualifications from "./components/Qualifications";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollUp from "./components/ScrollUp";
import Work from "./components/Work";
import { createContext, useState } from "react";
import { useEffect } from "react";
import './styles/load.css'



export const ThemeContext = createContext(null)

function App() {
  const [theme, setTheme] = useState('dark');
  const [data, setData] = useState([]);
  const [loading, setloading] = useState(undefined);
  const [completed, setcompleted] = useState(undefined);

  const toggleTheme = () => {
    setTheme((curr) => (curr === "light" ? "dark" : "light"))
  }

  useEffect(() => {
    setTimeout(() => {
      fetch("https://jsonplaceholder.typicode.com/posts")
        .then((response) => response.json())
        .then((json) => {
          // console.log(json);
          setData(json);
          setloading(true);

          setTimeout(() => {
            setcompleted(true);
          }, 2000);
        });
    }, 1000);
  }, []);

  return (
    <>
      <>
        {!completed ? (
          <>
            {!loading ? (
              <div className="spinner__container">
                <div className="spinner">
                  <img src="/assets/seucrasimg.png" alt="" loading="lazy" />

                  <div className="half-spinner"></div>
                </div>
              </div>
            ) : (
              <div className="completed__container">
                <div className="completed">
                  <img
                    style={{
                      borderRadius: "50%",
                      width: "150px",
                      height: "150px",
                    }}
                    src="/assets/seucrasimg.png"
                    alt=""
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <>
              <ThemeContext.Provider value={{ theme, toggleTheme }}>
                <div>
                  <Header toggleTheme={toggleTheme} theme={theme} />
                  <main className="main">
                    <Home theme={theme} />
                    <About theme={theme} />
                    <Skills theme={theme} />
                    <Services theme={theme} />
                    <Qualifications theme={theme} />
                    <Work theme={theme} />
                    <Testimonials theme={theme} />
                    <Contact theme={theme} />
                  </main>
                  <Footer theme={theme} />
                  <ScrollUp theme={theme} />
                </div>
              </ThemeContext.Provider>
            </>
          </>
        )}
      </>
    </>
  );
}

export default App;
